import { CircularProgress, Modal } from "@mui/material";
import { memo, useCallback, useContext, useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { UserContext } from "../../../../../../../../App";
import {
  fetchLoyality,
  getLoyaltyCorrespondingValue,
  redeemLoyalty,
  redeemLoyaltyOtp,
  // removeLoyalty,
  removeLoyaltyNew,
  validateLoyaltyOtp,
} from "../../../../../../../../config/Services";
import { eventTrackerConstant } from "../../../../../../../common/event-tracker/event-tracker-constants";
import { eventTracker } from "../../../../../../../common/event-tracker/eventTracker";
import { useSnackbar } from "../../../../../hooks/SnackbarProvider";
import useFetch from "../../../../../hooks/useFetch";
import { getCouponState } from "../../../../redux/Reducers/couponReducer";
import { customEventTrigger } from "../../../../../../../../analytics";
import "./loyalty-drawer.css";

/* ── Icons ─────────────────────────────────────────────── */

/* ── Main Component ─────────────────────────────────────── */
const LoyaltyPopupCustom = ({
  loyaltyModal,
  setOpen,
  handleCloseModal,
  setLoyaltyModal,
  setOpenCartCustomerDetail,
  setShowLoyalty,
  setPendingLoyaltyReopen,
}) => {
  const showSnackbar = useSnackbar();
  const { total, cartItems, setTotal, setLoyaltyPoints, couponApplied } = useContext(UserContext);
  const orgId = localStorage.getItem("orgId");
  const cartId = localStorage.getItem("CartId");
  const lPoints = localStorage.getItem("loyaltyPoints");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
  const userUidx = retailUserDetails?.uidx;
  const userName = localStorage.getItem("user_name");
  const customerDetails = JSON.parse(localStorage.getItem("customer_details") || "{}");
  const customerUidx = customerDetails?.uidx;
  const customerMobile = customerDetails?.mobileNumber;
  const customerName = customerDetails?.name || customerDetails?.firstName || "";

  const couponState = useSelector(getCouponState, shallowEqual);

  const [loyaltyData, setLoyaltyData] = useState(null);
  const [loyaltyPayloadValue, setLoyaltyPayloadValue] = useState(null);
  const [inputs, setInputs] = useState({ value: "", points: "" });
  const [otpReq, setOtpReq] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVal, setOtpVal] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [redeemLoader, setRedeemLoader] = useState(false);
  const [blacklisted, setBlacklisted] = useState({ stat: false, label: "" });

  const closeLoyaltyModal = useCallback(() => setLoyaltyModal(false), [setLoyaltyModal]);

  const [isCheckingCustomer, setIsCheckingCustomer] = useState(true);

  useEffect(() => {
    const checkCustomer = async () => {
      const prevUidx = localStorage.getItem("loyalty_prev_uidx");
      if (prevUidx !== null && prevUidx !== customerUidx) {
        const appliedPoints = localStorage.getItem("loyaltyPoints");

        // Clear local states
        localStorage.removeItem("loyaltyPoints");
        if (setLoyaltyPoints) setLoyaltyPoints("");
        if (setShowLoyalty) setShowLoyalty(false);

        setLoyaltyData(null);
        setLoyaltyPayloadValue(null);
        setInputs({ value: "", points: "" });

        if ((appliedPoints || couponApplied) && cartId) {
          try {
            setRedeemLoader(true);
            const payload = {
              cartId: cartId,
              updatedBy: userUidx,
              updatedByName: userName,
            };
            const res = await removeLoyaltyNew(payload);
            if (res?.data?.data?.data?.billing?.totalCartValue) {
              setTotal(res?.data?.data?.data?.billing?.totalCartValue);
            }
          } catch (e) {
            showSnackbar(e?.response?.data?.message || "Error removing loyalty", "error");
          } finally {
            setRedeemLoader(false);
          }
        }
      }
      localStorage.setItem("loyalty_prev_uidx", customerUidx || "");
      setIsCheckingCustomer(false);
    };
    checkCustomer();
  }, [customerUidx, cartId]);

  /* ── Fetch loyalty data ─── */
  const fetchRedeemPoints = useFetch({
    name: "fetch-loyality",
    service: fetchLoyality,
    params: {
      sourceOrgId: orgId,
      cartValue: total,
      customerType: "end_customer",
      customerId: customerUidx,
      couponApplied: Boolean(
        couponState &&
          couponState !== "0" &&
          couponState !== 0 &&
          (typeof couponState !== "object" || Object.keys(couponState).length > 0)
      ),
    },
    conditionalRefetch: [couponState, cartItems?.length, total, customerUidx],
    condition: !!customerUidx && loyaltyModal && !isCheckingCustomer,
  });

  useEffect(() => {
    if (fetchRedeemPoints.data) {
      // The useFetch dataExtractor returns the axios response data.
      // The expected structure is fetchRedeemPoints.data.data
      const res = fetchRedeemPoints?.data;
      if (res?.data) {
        setLoyaltyData(res?.data);
        setLoyaltyPayloadValue(res?.data);
        setOtpReq(!!res?.data?.otpValidation);
      } else {
        setBlacklisted({ stat: true, label: res?.message });
      }
    }
  }, [fetchRedeemPoints?.data]);

  /* Pre-fill inputs when data loads or modal opens */
  useEffect(() => {
    if (loyaltyData && loyaltyModal) {
      setInputs({
        value: loyaltyData.redeemablePointValue || "",
        points: loyaltyData.redeemablePoint || "",
      });
      setLoyaltyPayloadValue(loyaltyData);
    }
  }, [loyaltyData, loyaltyModal]);

  /* ── Handlers ─── */
  const handleAddCustomer = () => {
    customEventTrigger("add_customer_for_loyalty");
    setPendingLoyaltyReopen?.();
    setOpen(true);
    closeLoyaltyModal();
    setOpenCartCustomerDetail?.(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
    const payload = {
      sourceOrgId: orgId,
      cartValue: total,
      customerType: "end_customer",
      customerId: customerUidx,
      couponApplied: couponApplied === "0" ? false : true,
      customRedeemablePoints: name === "points" ? value : null,
      customRedeemableValue: name === "value" ? value : null,
    };
    getLoyaltyCorrespondingValue(payload).then((res) => {
      const d = res?.data?.data?.data;
      setLoyaltyPayloadValue(d);
      if (name === "points")
        setInputs((prev) => ({ ...prev, value: d?.redeemablePointValue || "" }));
      else setInputs((prev) => ({ ...prev, points: d?.redeemablePoint || "" }));
    });
  };

  const handleSendOtp = () => {
    if (
      inputs.value > loyaltyData?.redeemablePointValue ||
      inputs.points > loyaltyData?.redeemablePoint
    ) {
      showSnackbar(`Maximum redeemable value is ₹${loyaltyData?.redeemablePointValue}`, "error");
      return;
    }
    if (!loyaltyData?.redeemable) {
      showSnackbar("No available loyalty points to redeem", "error");
      return;
    }
    setOtpLoading(true);
    redeemLoyaltyOtp({ mobile: customerMobile })
      .then(() => {
        setOtpSent(true);
      })
      .catch(() => showSnackbar("Failed to send OTP", "error"))
      .finally(() => setOtpLoading(false));
  };

  const handleRedeem = () => {
    setRedeemLoader(true);
    const payload = {
      currencyCode: loyaltyData?.currencyCode,
      redeemablePoint: loyaltyPayloadValue?.redeemablePoint,
      redeemablePointValue: loyaltyPayloadValue?.redeemablePointValue,
      totalAvailablePoint: loyaltyPayloadValue?.totalAvailablePoint,
      availablePointValue: loyaltyPayloadValue?.availablePointValue,
      customRedeemablePoints: Number(inputs.points),
      customRedeemableValue: Number(inputs.value),
    };

    const doRedeem = () =>
      redeemLoyalty(payload, cartId)
        .then((res) => {
          setTotal(res?.data?.data?.billing?.totalCartValue);
          setLoyaltyPoints(res?.data?.data?.loyaltyPointsValue);
          localStorage.setItem("loyaltyPoints", res?.data?.data?.loyaltyPointsValue);
          if (setShowLoyalty) setShowLoyalty(true);
          eventTracker({
            metaData: {
              cartId,
              loyaltyPoints: inputs.points,
              phoneNumber: customerMobile,
              amount: res?.data?.data?.billing?.totalCartValue,
            },
            eventType: eventTrackerConstant.LOYALTY_AWARDED,
          });
          showSnackbar("Loyalty points applied successfully", "success");
          setRedeemLoader(false);
          setOtpSent(false);
          setOtpVal("");
          closeLoyaltyModal();
        })
        .catch((err) => {
          showSnackbar(
            err?.response?.data?.message || err?.message || "Could not redeem loyalty",
            "error"
          );
          setRedeemLoader(false);
        });

    if (otpReq && otpSent) {
      validateLoyaltyOtp({ mobile: customerMobile, otp: otpVal })
        .then(doRedeem)
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || "Invalid OTP", "error");
          setRedeemLoader(false);
        });
    } else {
      doRedeem();
    }
  };

  const handleRemove = () => {
    if (!cartId) {
      showSnackbar("Cart is not available to remove loyalty points", "error");
      return;
    }

    setRedeemLoader(true);
    const payload = {
      cartId: cartId,
      updatedBy: userUidx,
      updatedByName: userName,
    };
    removeLoyaltyNew(payload)
      .then((res) => {
        if (res?.data?.status === "error") {
          showSnackbar(res?.data?.message || "Something went wrong", "error");
          setRedeemLoader(false);
          return;
        }
        showSnackbar("Loyalty points removed successfully", "success");
        localStorage.removeItem("loyaltyPoints");
        if (setShowLoyalty) setShowLoyalty(false);
        setTotal(res?.data?.data?.data?.billing?.totalCartValue);
        setLoyaltyPoints(res?.data?.data?.data?.loyaltyPointsValue);
        setRedeemLoader(false);
        setOtpSent(false);
        setOtpVal("");
        closeLoyaltyModal();
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message, "error");
        setRedeemLoader(false);
      });
  };

  const pointsToShow = Number(inputs.points) || 0;
  const valueToShow = Number(inputs.value) || 0;
  const alreadyRedeemed = Number(lPoints) > 0 && lPoints != null;
  const otpEntered = otpVal.replace(/\s/g, "").length > 1;

  /* ── Render ─── */
  return (
    <Modal
      open={loyaltyModal}
      onClose={handleCloseModal}
      slotProps={{ backdrop: { style: { backgroundColor: "rgba(0,0,0,0.35)" } } }}
    >
      <div className="lyd-shell">
        {/* Header */}
        <div className="lyd-header">
          <div className="flex flex-1 items-center gap-4">
            <h1 className="lyd-title" data-testid="text-action-drawer-title">
              Loyalty
            </h1>
          </div>
          <button
            className="lyd-close"
            onClick={handleCloseModal}
            data-testid="button-action-drawer-close"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-x h-4 w-4 text-slate-500"
              aria-hidden="true"
            >
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="lyd-body">
          {!customerMobile ? (
            /* ── No customer state ── */
            <div className="lyd-no-customer">
              <div className="lyd-no-customer-card">
                <div className="lyd-no-customer-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-user h-6 w-6"
                    aria-hidden="true"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <p className="lyd-no-customer-title">Add customer to view loyalty points</p>
                <p className="lyd-no-customer-sub">
                  Attach a customer to this cart first, then loyalty redemption will be available
                  here.
                </p>
                <button className="lyd-add-customer-btn" onClick={handleAddCustomer}>
                  Add Customer
                </button>
              </div>
            </div>
          ) : (
            /* ── Customer present state ── */
            <>
              {/* Customer card */}
              <div className="lyd-customer-card">
                <div className="lyd-customer-row">
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
                    <div className="lyd-avatar">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-user h-6 w-6"
                        aria-hidden="true"
                      >
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                    </div>
                    <div className="lyd-customer-info">
                      <h4 className="lyd-customer-name" data-testid="text-loyalty-customer-name">
                        {customerName || "Customer"}
                      </h4>
                      <p className="lyd-customer-phone" data-testid="text-loyalty-customer-phone">
                        {customerDetails?.countryCode
                          ? `+${customerDetails.countryCode} ${customerMobile}`
                          : customerMobile}
                      </p>
                      {customerDetails?.email && (
                        <p className="lyd-customer-email" data-testid="text-loyalty-customer-email">
                          {customerDetails.email}
                        </p>
                      )}
                    </div>
                  </div>
                  {(loyaltyData?.tier || loyaltyData?.loyaltyTier) && (
                    <div className="lyd-tier-badge" data-testid="badge-loyalty-tier">
                      {loyaltyData?.tier || loyaltyData?.loyaltyTier}
                    </div>
                  )}
                </div>

                <div className="lyd-customer-meta-grid">
                  {(loyaltyData?.memberId || customerDetails?.memberId) && (
                    <div className="lyd-meta-tile">
                      <p className="lyd-meta-label">Member ID</p>
                      <p className="lyd-meta-value" data-testid="text-loyalty-member-id">
                        {loyaltyData?.memberId || customerDetails?.memberId}
                      </p>
                    </div>
                  )}
                  <div className="lyd-meta-tile">
                    <p className="lyd-meta-label">Visits</p>
                    <p className="lyd-meta-value" data-testid="text-loyalty-visits">
                      {loyaltyData?.visits || "0"}
                    </p>
                  </div>
                  <div className="lyd-meta-tile">
                    <p className="lyd-meta-label">Last visited</p>
                    <p className="lyd-meta-value" data-testid="text-loyalty-last-visit">
                      {loyaltyData?.lastVisited || "0 days ago"}
                    </p>
                  </div>
                </div>
              </div>

              {fetchRedeemPoints?.isLoading ? (
                <div className="lyd-loader">
                  <CircularProgress size={32} sx={{ color: "#2563eb" }} />
                </div>
              ) : blacklisted.stat ? (
                <div className="lyd-blacklisted">{blacklisted.label}</div>
              ) : (
                <>
                  {/* Stats tiles */}
                  <div className="lyd-stats">
                    <div className="lyd-stat-tile">
                      <div className="lyd-stat-header">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-wallet h-4 w-4"
                          aria-hidden="true"
                        >
                          <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                          <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                        </svg>
                        <p className="lyd-stat-label">Loyalty</p>
                      </div>
                      <p className="lyd-stat-value" data-testid="text-loyalty-total-points">
                        {loyaltyData?.totalAvailablePoint ?? "0"} pts
                      </p>
                      <p className="lyd-stat-sub">available now</p>
                    </div>

                    <div className="lyd-stat-tile">
                      <div className="lyd-stat-header">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-sparkles h-4 w-4"
                          aria-hidden="true"
                        >
                          <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>
                          <path d="M20 2v4"></path>
                          <path d="M22 4h-4"></path>
                          <circle cx="4" cy="20" r="2"></circle>
                        </svg>
                        <p className="lyd-stat-label">Eligible</p>
                      </div>
                      <p className="lyd-stat-value" data-testid="text-loyalty-eligible-points">
                        {loyaltyData?.redeemablePoint ?? "0"} pts
                      </p>
                      <p className="lyd-stat-sub">for this order</p>
                    </div>

                    <div className="lyd-stat-tile">
                      <div className="lyd-stat-header">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-badge-check h-4 w-4"
                          aria-hidden="true"
                        >
                          <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
                          <path d="m9 12 2 2 4-4"></path>
                        </svg>
                        <p className="lyd-stat-label">Max value</p>
                      </div>
                      <p className="lyd-stat-value" data-testid="text-loyalty-eligible-value">
                        ₹{(loyaltyData?.redeemablePointValue ?? 0).toFixed(2)}
                      </p>
                      <p className="lyd-stat-sub">redeemable now</p>
                    </div>
                  </div>

                  {/* Redemption section */}
                  <div className="lyd-section">
                    <div>
                      <span className="lyd-section-label">Redemption amount</span>
                      <p className="lyd-section-sub">
                        Enter either points or value. The matching amount updates automatically.
                      </p>
                    </div>
                    <div className="lyd-inputs-row">
                      <div className="lyd-input-group">
                        <label className="lyd-input-label">Points to redeem</label>
                        <input
                          className="lyd-input"
                          type="text"
                          inputMode="numeric"
                          name="points"
                          placeholder="Enter points"
                          value={inputs.points}
                          onChange={handleInputChange}
                          data-testid="input-loyalty-points"
                        />
                      </div>
                      <div className="lyd-input-group">
                        <label className="lyd-input-label">Value to redeem</label>
                        <input
                          className="lyd-input"
                          type="text"
                          inputMode="decimal"
                          name="value"
                          placeholder="Enter value"
                          value={inputs.value}
                          onChange={handleInputChange}
                          data-testid="input-loyalty-value"
                        />
                      </div>
                    </div>
                    <div className="lyd-preview-row">
                      <span>Redemption preview</span>
                      <span className="lyd-preview-val" data-testid="text-loyalty-preview">
                        {pointsToShow} pts = ₹{valueToShow?.toFixed(2)}
                      </span>
                    </div>

                    {/* OTP section */}
                    {otpReq && (
                      <div className="lyd-otp-section">
                        <div className="lyd-otp-header-row">
                          <div className="lyd-otp-left">
                            <span className="lyd-otp-label">OTP verification</span>
                            <p className="lyd-otp-sub">
                              {otpSent
                                ? `Enter the OTP sent to ${customerMobile}`
                                : "Validate the customer OTP before applying redeemed value."}
                            </p>
                          </div>
                          {!otpSent && (
                            <button
                              className="lyd-send-otp-btn"
                              onClick={handleSendOtp}
                              disabled={otpLoading}
                              data-testid="button-send-loyalty-otp"
                            >
                              {otpLoading ? (
                                <CircularProgress size={14} sx={{ color: "#047857" }} />
                              ) : (
                                <>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-phone mr-2 h-4 w-4"
                                    aria-hidden="true"
                                  >
                                    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
                                  </svg>{" "}
                                  Send OTP
                                </>
                              )}
                            </button>
                          )}
                        </div>
                        {otpSent && (
                          <>
                            <input
                              className="lyd-otp-input"
                              type="number"
                              placeholder="Enter OTP"
                              value={otpVal}
                              onChange={(e) => setOtpVal(e.target.value)}
                            />
                            <button className="lyd-otp-resend" onClick={handleSendOtp}>
                              Resend OTP
                            </button>
                          </>
                        )}
                      </div>
                    )}

                    {/* Redeem/Remove Button inside the card flow */}
                    {alreadyRedeemed ? (
                      <button
                        className="lyd-redeem-btn lyd-redeem-btn--remove"
                        onClick={handleRemove}
                        disabled={redeemLoader}
                        data-testid="button-redeem-loyalty"
                      >
                        {redeemLoader ? (
                          <CircularProgress size={16} sx={{ color: "#fff" }} />
                        ) : (
                          "Remove Loyalty"
                        )}
                      </button>
                    ) : (
                      <button
                        className="lyd-redeem-btn"
                        onClick={handleRedeem}
                        disabled={
                          redeemLoader ||
                          (otpReq && (!otpSent || !otpEntered)) ||
                          !loyaltyData?.redeemable
                        }
                        data-testid="button-redeem-loyalty"
                      >
                        {redeemLoader ? (
                          <CircularProgress size={16} sx={{ color: "#fff" }} />
                        ) : (
                          `Redeem ${pointsToShow} pts for ₹${valueToShow?.toFixed(2)}`
                        )}
                      </button>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default memo(LoyaltyPopupCustom);
